import { HttpService, MessageService, ModalService } from '@philips-emr/tws-core/lib/services';

import { Endpoint } from '../constants';

interface Termo {
  dsTermo: string,
  nrSequencia: number,
  tipo: string,
}

class TermsService {

  public static openTermModal(term: Termo): void {
    let title = '';
    if (term) {
      title = term.tipo == 'TU' ? MessageService.translate('$expression.$862648')
        : MessageService.translate('$expression.$862646');
      ModalService.openDefault({
        id: 'term-modal',
        closeable: false,
        fragment: 'assign-term',
        title: title,
        contextData: { ...term },
      });
    }
  }

  public static checkTerms(): void {
    void HttpService.get<Termo[]>(Endpoint.GET.TERMOS).then((response) => {
      const terms = response.body;

      if (terms && terms.length > 0) {
        const term = terms.pop();
        if (term) {
          this.openTermModal(term);
        }
      }
    });
  }

}

export {
  Termo, TermsService,
};
